export default __webpack_public_path__ + "static/media/pic5.4ef54b1f.jpg";